import { render, staticRenderFns } from "./MyMedal.vue?vue&type=template&id=6d778fea&"
import script from "./MyMedal.vue?vue&type=script&lang=js&"
export * from "./MyMedal.vue?vue&type=script&lang=js&"
import style0 from "./MyMedal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports